module.exports = __webpack_public_path__ + "img/Morbida.50314009.png";